module.exports = __webpack_public_path__ + "img/Logo.640046c2.png";